const styles = () => ({
  formControl: {
    minWidth: 120,
    margin: 20,
  },
})

export default styles
